import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import NavbarRoutes from './components/NavbarRoutes';
import HomePage from './pages/HomePage';
import HowItWorksPage from './pages/HowItWorksPage';
import WhyJoinPage from './pages/WhyJoinPage';
import DAOPage from './pages/DAOPage';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';
import Footer from './components/Footer';
import ImpactShowcasePage from './pages/ImpactShowcasePage';
import MerchPage from './pages/MerchPage';
import NotFoundPage from './pages/NotFoundPage';
import ComingSoonPage from './pages/ComingSoonPage';
import ReportBugPage from './pages/ReportBugPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-neutral-bg">
          <NavbarRoutes />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/why-join" element={<WhyJoinPage />} />
            <Route path="/dao" element={<DAOPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/coming-soon" element={<ComingSoonPage />} />
            <Route path="/impact" element={<ImpactShowcasePage />} />
            <Route path="/merch" element={<MerchPage />} />
            <Route path="/report-bug" element={<ReportBugPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
